module.exports = __webpack_public_path__ + "sprite/buttons@2x.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons@2x.json
// module id = 111
// module chunks = 3